@if (showWindow) {
<div class="m-0 p-0">
  @if (UserProfileService.apiCallsInProgress.length > 0) {
<app-loader></app-loader>
}
  @if (userProfile) {
<div class="page-body">
      <app-up-general
      [actions]="action"
      [source]="UPEnums.SourceMyProfile"
      [userId]="''"
      [userProfile]="userProfile"
      (onClosePopup)="checkUnsavedDataBeforeClosing()"
      (profileModified)="onProfileModified($event);"
      ></app-up-general>


    <app-up-rims-service [actions]="action"
    [source]="UPEnums.SourceMyProfile"
    [userProfile]="userProfile"
    (onClosePopup)="checkUnsavedDataBeforeClosing()"
    (profileModified)="onProfileModified($event)"
    ></app-up-rims-service>

    <app-up-rims-sales [actions]="action"
    [source]="UPEnums.SourceMyProfile"
    [userProfile]="userProfile"
    (onClosePopup)="checkUnsavedDataBeforeClosing()"
    (profileModified)="onProfileModified($event)"
    ></app-up-rims-sales>


  </div>
}
  <div class="buttons-footer">
    @if (getPermission('unlockAccountButton')?.visible) {
    <button type="button" style="background-color: #A9A9A9;" (click)="unlockAccount()" [disabled]="!getPermission('unlockAccountButton')?.enable || lockAccountButtonText == 'Unlocked'" class="btn btn-sm">{{lockAccountButtonText}}</button>
  }
  @if (getPermission('resetAuthButton')?.visible) {
    <button type="button" style="color: whitesmoke;" (click)="resetAuth()" [disabled]="!getPermission('resetAuthButton')?.enable || isResetAuthDisabled" class="btn btn-sm btn-warning">Reset Authentication</button>
  }
  @if (getPermission('changePasswordButton')?.visible) {
    <button type="button" style="background-color: #808080;" (click)="setChangePasswordFlag()" [disabled]="!getPermission('changePasswordButton')?.enable" class="btn btn-sm">Change Password On Login</button>
  }
  @if (getPermission('resetPersistenceButton')?.visible) {
    <button type="button" style="background-color: #007BFF;" (click)="resetProfilePersistence()" [disabled]="!getPermission('resetPersistenceButton')?.enable" class="btn btn-sm">Reset Persistence</button>
  }
  @if (getPermission('saveButton')?.visible) {
    <button type="button" style="background-color: #28A745;" [disabled]="!enableSaveButton || !getPermission('saveButton')?.enable" class="btn btn-sm btn-success" (click)="saveButtonClick()">Save</button>
  }
  </div>
</div>
}
